import LoopbackHttp from '../businessLogic/LoopbackHttp.js';

export const getOldDashboardOrdersFilter = (companyId, today, tomorrow) => {
  return `&filter={
  	"include": [
  		${
        !LoopbackHttp.isOperator ?
        `{
    			"relation": "items",
    			"scope": {
    				"fields": ["id", "pickupPointId"],
    				"include": {
    					"relation": "pickUpPoint",
    					"scope": {
    						"fields": ["id", "gpsLocation", "address"]
    					}
    				}
    			}
    		},`
        : ''
      }
  		{
  			"relation": "recipient",
  			"scope": { "fields": ["id", "gpsLocation", "deliveryPoint", "firstName"]}
  		},
  		{
  			"relation": "driver",
  			"scope": {
           "fields": ["id", "firstName"]
         }
  		}
  	],
  	"where": {
  			"and":
  				[
  					${companyId ? `{"companyId":"${companyId}"},` : ''}
  					{"orderStatus":{ "nin": ["canceled", "returned", "delivered"] }}
            ${today && tomorrow ? `,{"expectedPickUpTime.endTime": { "between": [${today}, ${tomorrow}]}}`: ``}
  				]
  	},
  	"fields": ["id", "orderStatus", "expectedPickUpTime", "deliveryCommission", "cashOnDeliveryAmount", "cashOnDelivery", "express", "isOutOfCity",
     "driverId", "recipientId", "createdBy", "vehicleType", "deliveryTime", "createdAt"]
  }`;
};

export const getActiveDriversForDashboard = (companyId) => `&filter={
  "include": [
    {
      "relation": "driverGpsLocations"
    }
  ],
	"where": {
			"and":
				[
					{"companyId":"${companyId}"},
					{"driverStatus":"active"}
				]
	},
	"fields": ["id", "firstName", "vehicleType", "driverStatus"]
}`;

export const getDriversForFleetSettings = () => `&filter={
	"fields": ["id", "firstName", "email", "driverStatus"]
}`;

export const getDriver = () => `&filter={
}`;

export const getPlatform = () => `&filter={
}`;

export const getCities= (id) => `&filter={
  "where": {
    "countryId": "${id}"
  },
  "fields": {
		"id": true,
    "name": true
	}
}`;


export const getPlatformsForFleetSettings = () => `&filter={
	"fields": ["id", "name", "email"]
}`;

export const getDriverGpsLocation = (driverIds) => `&filter={
	"where": {
			"driverId": {"inq":[${driverIds}]}
	}
}`;

export const getTeamsForDashboard = (companyId) => `&filter={
  "include": [
    {
      "relation": "drivers",
      "scope": {
        "fields": ["id", "firstName", "vehicleType", "cashOnDelivery", "driverStatus", "blocked"]
      }
    }
  ],
  ${companyId
    ? `"where": { "companyId":"${companyId}" },`
    : ''}
	"fields": {
		"id": true,
    "name": true,
    "polygon": true
	}
}`;

export const getTeamsForUser = () => `&filter={
	"fields": {
		"id": true,
    "name": true
	}
}`;

export const getTeamsForSettings = (companyId) => `&filter={
  ${companyId
    ? `"where": { "companyId":"${companyId}" },`
    : ''}
	"fields": {
		"id": true,
    "name": true,
    "default": true
	}
}`;

export const getTeamsForOrderCreation = (companyId) => `&filter={
  ${companyId
    ? `"where": { "companyId":"${companyId}" },`
    : ''}
	"fields": {
		"id": true
	}
}`;

export const getFleetOperators = () => `&filter={
	"fields": [
		"id",
		"firstName",
    "email"
	]
}`;

export const getOperator = () => `&filter={
	"fields": [
		"id",
		"cityId",
    "phone",
    "countryId",
    "canAddDispatcher",
    "canAddDriver",
    "canCreateOrders",
    "teamId"
	]
}`;

export const getFleetDispatchers = () => `&filter={
	"fields": [
		"id",
		"firstName",
    "email",
    "shopName"
	]
}`;

export const getDispatcher = () => `&filter={
	"fields": [
		"id",
		"cityId",
    "countryId",
    "teamId",
    "mobile",
    "phone",
    "active",
    "deliveryCommission",
    "expressDeliveryCommission",
    "distanceBasedModifiers"
	]
}`;

export const getTeamsAndDriversForOperator = () => `&filter={
  "include": [
        {
            "relation": "drivers",
            "scope": {
                "fields": [
                    "id", "firstName", "vehicleType", "driverStatus", "cashOnDelivery"
                ],
                "include": {
                    "relation": "driverGpsLocations",
                    "scope": {
                        "fields": [
                            "gpsLocation"
                        ]
                    }
                }
            }
        }
    ]
}`;

export const getOrderForDetails = () => {
  return `&filter={
  	"include": [
  		{
  			"relation": "items",
  			"scope": {
  				"fields": ["id", "packingList", "pickupPointId"],
  				"include": {
  					"relation": "pickUpPoint",
  					"scope": {
  						"fields": ["id", "address", "contactName", "contactPhone"]
  					}
  				}
  			}
  		},
  		{
  			"relation": "recipient",
  			"scope": { "fields": ["id", "firstName", "mobile", "deliveryPoint", "gpsLocation", "outOfCityAddress"]}
  		},
  		{
  			"relation": "driver",
  			"scope": {
           "fields": ["id", "firstName", "phone", "driverCommissionPercent"]
         }
  		}
  	],
  	"fields": ["id", "orderStatus", "expectedPickUpTime", "deliveryCommission", "driverId", "recipientId", "createdBy", "vehicleType", "deliveryTime",
    "createdAt", "cashOnDeliveryAmount", "isFixed", "cashOnDelivery", "express", "isOutOfCity"]
  }`;
};

export const getDispatcherOrders = (id) => {
  return `&filter={
    "include": [
      {
        "relation": "items",
        "scope": {
          "fields": ["id", "pickupPointId"]
        }
      }
    ],
    "where": {
  			"and":
  				[
  					{"dispatcherId":"${id}"},
  					{"orderStatus":{ "nin": ["canceled", "returned", "delivered"] }}
  				]
  	},
  	"fields": ["id", "orderStatus", "expectedPickUpTime", "vehicleType",
    "deliveryTime", "orderCreatedTime", "express", "isOutOfCity"]
  }`;
};

export const getTeamForSettings = () => {
  return `&filter={
    "include": [
  		{
  			"relation": "drivers",
  			"scope": { "fields": ["id", "firstName"]}
  		},
      {
  			"relation": "operators",
  			"scope": { "fields": ["id", "firstName"]}
  		},
      {
  			"relation": "dispatchers",
  			"scope": { "fields": ["id", "firstName"]}
  		}
  	]
  }`;
};

export const getAllOperatorUsers = () => {
  return `&filter={
    "include": [
      {
        "relation": "drivers",
        "scope": { "fields": ["id", "firstName"]}
      },
      {
        "relation": "operators",
        "scope": { "fields": ["id", "firstName"]}
      },
      {
        "relation": "dispatchers",
        "scope": { "fields": ["id", "firstName"]}
      },
      {
        "relation": "dispatcherPlatforms",
        "scope": { "fields": ["id", "name"]}
      }
    ]
  }`;
};

export const getOperatorOperators = () => {
  return `&filter={
    "include": [
      {
        "relation": "operators",
        "scope": { "fields": ["id", "firstName", "email"]}
      }
    ]
  }`;
};

export const getOperatorDispatchers = () => {
  return `&filter={
    "include": [
      {
        "relation": "dispatchers",
        "scope": { "fields": ["id", "firstName", "email", "shopName"]}
      }
    ]
  }`;
};

export const getOperatorDrivers= () => {
  return `&filter={
    "include": [
      {
        "relation": "drivers",
        "scope": { "fields": ["id", "firstName", "email", "driverStatus", "blocked"]}
      }
    ]
  }`;
};

export const getOperatorActiveDrivers= () => {
  return `&filter={
    "include": [
      {
        "relation": "drivers",
        "scope": {
          "fields": ["id", "firstName", "email", "driverStatus", "blocked"],
          "where": {
            "and":
              [
                {"driverStatus":"active"}
              ]
          },
          "include": [
            {
              "relation": "driverGpsLocations"
            }
          ]
        }
      }
    ]
  }`;
};

export const getOperatorPlatforms = () => {
  return `&filter={
    "include": [
      {
        "relation": "dispatcherPlatforms",
        "scope": { "fields": ["id", "name", "email"]}
      }
    ]
  }`;
};



// WEBPACK FOOTER //
// ./src/constants/filtersForLoopback.js